import { render, staticRenderFns } from "./table-footer-goal-setting.component.vue?vue&type=template&id=cbe7f59c&scoped=true"
import script from "./table-footer-goal-setting.component.vue?vue&type=script&lang=ts"
export * from "./table-footer-goal-setting.component.vue?vue&type=script&lang=ts"
import style0 from "./table-footer-goal-setting.component.vue?vue&type=style&index=0&id=cbe7f59c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe7f59c",
  null
  
)

export default component.exports